require('assets/css/fonts/iconfont.css')
require('assets/scss/ionic.app.scss')
require('assets/scss/style.scss')

// http://code.angularjs.org/1.2.1/docs/guide/bootstrap#overview_deferred-bootstrap
window.name = 'NG_DEFER_BOOTSTRAP!'

const angular = require('angular')
const ng = angular.injector(['ng'])
const $q = ng.get('$q')
const app = require('js/app')
const cssVars = require('css-vars-ponyfill')
require('js/routes')

window.HX = require('js/global/module')
const { version: globalVersion, config: globalConfig } = window.HX

console.info(globalVersion)
cssVars.default() // 兼容不支持css自定义变量的低版本安卓浏览器

function bootstrapApp() {
  angular.element().ready(function () {
    angular.resumeBootstrap([app['name']])
  })
}

$q.resolve()
  .then(_ => globalConfig.getDomainOrgId())
  .then(_ => globalConfig.getClientConf())
  .then(_ => globalConfig.getI18nConf())
  .finally(bootstrapApp)
  .catch(console.error) // 未注入angular应用的q服务then会捕获错误导致vconsole无法打印，因此需要主动打印下



// WEBPACK FOOTER //
// ./src/js/main.js